(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', '$injector'];

    function notificationInterceptor ($q, $injector) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            // Requests may opt out of the auto success toast (e.g. a file upload that is an internal
            // step of a larger save, where the parent entity's own alert is the meaningful one).
            var requestHeaders = (response.config && response.config.headers) || {};
            if (requestHeaders['X-Skip-Success-Alert']) {
                return response;
            }
            // Show success alert
            var alertKey = response.headers('X-valueconnectApp-alert');
            if (angular.isString(alertKey)) {
                var AlertService = $injector.get('AlertService');
                AlertService.success(alertKey, { param : response.headers('X-valueconnectApp-params')});
            }
            return response;
        }
    }
})();
